module.exports = __webpack_public_path__ + "media/images/lp/lp06-5e4251819fb2470713b44439aea2f7a1.webp";